import { utl_parseData, html } from "../base/_utils";
import Papa from "papaparse";

console.log("past champs");

async function getAndDisplayData() {
    const pastChampsData = "https://docs.google.com/spreadsheets/d/e/2PACX-1vQlThNVSp1zukIrwKllbophSol64UiYfDTBWU_nMrxQAXQPYGKLlp2_Kw79dzEWyRx7jo9Wnn7YN81u/pub?gid=275875311&single=true&output=csv";

    try {
        // Fetch and parse the data
        const results = await utl_parseData(pastChampsData, Papa);
        let data = results.data;

        // Group the data by year_location
        let groupedData = {};

        data.forEach((row) => {
            const yearLocation = row.year_location;
            if (!groupedData[yearLocation]) {
                groupedData[yearLocation] = [];
            }
            groupedData[yearLocation].push(row);
        });

        // Display the grouped data
        const listContainer = document.querySelector("#past-champs-list");
        listContainer.innerHTML = ""; // Clear the container

        for (let yearLocation in groupedData) {
            listContainer.innerHTML += html`
                <div class="year-section">
                    <p class="fst-italic lead text-secondary mb-0">${yearLocation}</p>
                    <ul class="list-unstyled">
                        ${groupedData[yearLocation].map((item) => html` <li><strong>${item.name}</strong> ${item.event}</li> `).join("")}
                    </ul>
                </div>
            `;
        }

        listContainer.classList.remove("vh-100", "opacity-0");
    } catch (error) {
        // Handle errors
        console.error("Error parsing data:", error);
    }
}

getAndDisplayData();
